import Layout from '@/layout'

export const erp = [
  {
    path: '/erp/finance',
    component: Layout,
    redirect: '/erp/finance/stock',
    alwaysShow: true,
    name: 'ERPFinance',
    meta: {
      title: '进销存管理',
      icon: 'finance',
      permission_uri: '/erp/finance'
    },
    children: [{
      path: 'stock',
      name: 'Stock',
      component: () => import('@/views/erp/finance/stock.vue'),
      meta: {
        title: '出入库管理',
        permission_uri: '/erp/finance/stock',
        icon: 'fund'
      }
    }, {
      path: 'product',
      name: 'Product',
      component: () => import('@/views/erp/finance/product.vue'),
      meta: {
        title: '产品管理',
        permission_uri: '/erp/finance/product',
        icon: 'rule'
      }
    }, {
      path: 'stockAddress',
      name: 'StockAddress',
      component: () => import('@/views/erp/finance/stockAddress.vue'),
      meta: {
        title: '仓库地址管理',
        permission_uri: '/erp/finance/stockAddress',
        icon: 'task'
      }
    }, {
      path: 'customer',
      name: 'Customer',
      component: () => import('@/views/erp/finance/customer.vue'),
      meta: {
        title: '客户管理',
        permission_uri: '/erp/finance/customer',
        icon: 'admin'
      }
    }, {
      path: 'supplier',
      name: 'Supplier',
      component: () => import('@/views/erp/finance/supplier.vue'),
      meta: {
        title: '供应商管理',
        permission_uri: '/erp/finance/supplier',
        icon: 'fund-check'
      }
    }, {
      path: 'combination',
      name: 'Combination',
      component: () => import('@/views/erp/finance/combination.vue'),
      meta: {
        title: '组合管理',
        permission_uri: '/erp/finance/combination',
        icon: 'compose'
      }
    }, {
      path: 'consumables',
      name: 'Consumables',
      component: () => import('@/views/erp/finance/consumables.vue'),
      meta: {
        title: '耗材录入',
        permission_uri: '/erp/finance/consumables',
        icon: 'log'
      }
    }]
  },
  {
    path: '/erp/permission',
    component: Layout,
    redirect: '/erp/permission/member',
    name: 'ERPPermission',
    alwaysShow: true,
    meta: {
      title: '权限管理',
      icon: 'permission',
      permission_uri: '/erp/permission'
    },
    children: [{
      path: 'member',
      name: 'ERPPermissionMember',
      component: () => import('@/views/erp/permission/member'),
      meta: {
        title: '成员管理',
        icon: 'user',
        permission_uri: '/erp/permission/member'
      }
    }]
  }
]
